/* eslint-disable quotes */
/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { ReviewsWrapper } from './styles'
import { Header2, Header3 } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import { Swiper, SwiperSlide } from 'swiper/react'
import { createBugsnagErrorBoundary } from '../../helpers'
import SwiperCore from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css/bundle'

const ReviewsBugsnagErrorBoundary = createBugsnagErrorBoundary('events-reviews')

const ratings = [
  {
    quote: `“I just have to say that y'all are an executive assistant's DREAM. Thank you for making my job easy.”`,
    name: 'Kelsey J.',
  },
  {
    quote:
      '“All were courteous and did a great job juggling us all. The finished product was great too.”',
    name: 'Melissa R.',
  },
  {
    quote:
      '“Super convenient, and the stylists were friendly, professional, and efficient.”',
    name: 'Cynthia K.',
  },
]

const Reviews = () => {
  SwiperCore.use([Pagination, Autoplay, Navigation])
  return (
    <ReviewsWrapper>
      <Header2 color={gsColors.salmon} margin="0 0 32px">
        Everyone&apos;s buzzing
      </Header2>
      <div className="swiper-container-container">
        <ReviewsBugsnagErrorBoundary>
          <Swiper
            modules={[Navigation, Autoplay]}
            slidesPerView={1}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            navigation={{
              nextEl: '.custom-next-button',
              prevEl: '.custom-prev-button',
            }}
            className="swiper-container"
          >
            {ratings.map((r, i) => (
              <SwiperSlide key={i}>
                <div className="rating">
                  <div className="star-container">
                    {new Array(5).fill('').map((_, i) => (
                      <img
                        key={i}
                        src="/home/star.svg"
                        width="24"
                        height="24"
                        alt="star"
                      />
                    ))}
                  </div>
                  <Header3 color="#fff" align="center" margin="0 0 16px 0">
                    {r.quote}
                  </Header3>
                  <Header3 color="#fff" align="center">
                    - {r.name}
                  </Header3>
                </div>
              </SwiperSlide>
            ))}
            <button className="custom-prev-button" />
            <button className="custom-next-button" />
          </Swiper>
        </ReviewsBugsnagErrorBoundary>
      </div>
    </ReviewsWrapper>
  )
}

export default Reviews
